import { __values, __read } from 'tslib';
import { forkJoin, of, AsyncSubject, ReplaySubject } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { InjectionToken, Injectable, NgModule, Inject, defineInjectable, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var SEATGEEK_CONNECTION_CONFIG = new InjectionToken('Seatgeek connection configuration');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Execution order in parse[]FromFile:
 * -prepare: reformat the file content if necessary to match the parser input interface
 * -parse: parse the file contents in proper data structure
 * -merge: merge information into top-level structure
 */
var FileParserHelperService = /** @class */ (function () {
    function FileParserHelperService(http) {
        this.http = http;
    }
    /* Area parsing: top-level, prepare and parse*/
    /* Area parsing: top-level, prepare and parse*/
    /**
     * @protected
     * @param {?} idsTranslation
     * @return {?}
     */
    FileParserHelperService.prototype.prepareAreaIds = /* Area parsing: top-level, prepare and parse*/
    /**
     * @protected
     * @param {?} idsTranslation
     * @return {?}
     */
    function (idsTranslation) {
        return (/** @type {?} */ (idsTranslation));
    };
    /**
     * @protected
     * @param {?} idsTranslation
     * @return {?}
     */
    FileParserHelperService.prototype.parseAreaIds = /**
     * @protected
     * @param {?} idsTranslation
     * @return {?}
     */
    function (idsTranslation) {
        var e_1, _a;
        /** @type {?} */
        var holder = (/** @type {?} */ ({
            frommmc: { seats: {}, areas: {} },
            fromseatgeek: { areas: {} }
        }));
        try {
            for (var _b = __values(Object.entries(idsTranslation)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), id = _d[0], seatgeekId = _d[1];
                holder.frommmc.areas[id] = { seatgeekId: seatgeekId.toUpperCase(), name: id, seats: {} };
                holder.fromseatgeek.areas[seatgeekId.toUpperCase()] = id;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return holder;
    };
    /**
     * @protected
     * @param {?} file
     * @return {?}
     */
    FileParserHelperService.prototype.parseAreaIdsFromFile = /**
     * @protected
     * @param {?} file
     * @return {?}
     */
    function (file) {
        return this.http.get(file).pipe(map(this.prepareAreaIds), map(this.parseAreaIds));
    };
    /* Seat parsing: top-level, prepare and parse*/
    /* Seat parsing: top-level, prepare and parse*/
    /**
     * @protected
     * @param {?} idsTranslation
     * @return {?}
     */
    FileParserHelperService.prototype.prepareSeatIds = /* Seat parsing: top-level, prepare and parse*/
    /**
     * @protected
     * @param {?} idsTranslation
     * @return {?}
     */
    function (idsTranslation) {
        return (/** @type {?} */ (idsTranslation));
    };
    /**
     * @protected
     * @param {?} idsTranslation
     * @param {?} holder
     * @param {?} areaId
     * @return {?}
     */
    FileParserHelperService.prototype.parseSeatIds = /**
     * @protected
     * @param {?} idsTranslation
     * @param {?} holder
     * @param {?} areaId
     * @return {?}
     */
    function (idsTranslation, holder, areaId) {
        var e_2, _a;
        try {
            for (var _b = __values(Object.entries(idsTranslation)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), id = _d[0], seatgeekId = _d[1];
                holder.frommmc.seats[id] = seatgeekId.toUpperCase();
                holder.frommmc.areas[areaId].seats[seatgeekId.toUpperCase()] = id;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return holder;
    };
    /**
     * @protected
     * @param {?} filePath
     * @param {?} holder
     * @return {?}
     */
    FileParserHelperService.prototype.parseSeatsIdsFromFile = /**
     * @protected
     * @param {?} filePath
     * @param {?} holder
     * @return {?}
     */
    function (filePath, holder) {
        var _this = this;
        var e_3, _a;
        /** @type {?} */
        var observables = [];
        var _loop_1 = function (areaId, sector) {
            /** @type {?} */
            var file = filePath + "/" + areaId + ".json";
            observables.push(this_1.http.get(file).pipe(map(this_1.prepareSeatIds), map((/**
             * @param {?} data
             * @return {?}
             */
            function (data) { return _this.parseSeatIds(data, holder, areaId); }))));
        };
        var this_1 = this;
        try {
            for (var _b = __values(Object.entries(holder.frommmc.areas)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), areaId = _d[0], sector = _d[1];
                _loop_1(areaId, sector);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return forkJoin(observables).pipe(map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) { return data[0]; })));
    };
    /* seat area parsing */
    /* seat area parsing */
    /**
     * @protected
     * @param {?} areaPath
     * @param {?} seatPath
     * @return {?}
     */
    FileParserHelperService.prototype.parseAreasAndSeats = /* seat area parsing */
    /**
     * @protected
     * @param {?} areaPath
     * @param {?} seatPath
     * @return {?}
     */
    function (areaPath, seatPath) {
        var _this = this;
        return this.parseAreaIdsFromFile(areaPath).pipe(switchMap((/**
         * @param {?} data
         * @return {?}
         */
        function (data) { return _this.parseSeatsIdsFromFile(seatPath, data); })));
    };
    /* Parse section in areas: top-level, prepare and parse*/
    /* Parse section in areas: top-level, prepare and parse*/
    /**
     * @protected
     * @param {?} sectionInAreas
     * @return {?}
     */
    FileParserHelperService.prototype.prepareSectionInAreas = /* Parse section in areas: top-level, prepare and parse*/
    /**
     * @protected
     * @param {?} sectionInAreas
     * @return {?}
     */
    function (sectionInAreas) {
        return (/** @type {?} */ (sectionInAreas));
    };
    /**
     * @protected
     * @param {?} idsTranslation
     * @return {?}
     */
    FileParserHelperService.prototype.parseSectionInAreas = /**
     * @protected
     * @param {?} idsTranslation
     * @return {?}
     */
    function (idsTranslation) {
        var e_4, _a, e_5, _b;
        /** @type {?} */
        var holder = (/** @type {?} */ ({ areaPrices: idsTranslation, sectors: {} }));
        try {
            for (var _c = __values(Object.entries(idsTranslation)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = __read(_d.value, 2), id = _e[0], sectors = _e[1];
                try {
                    for (var sectors_1 = __values(sectors), sectors_1_1 = sectors_1.next(); !sectors_1_1.done; sectors_1_1 = sectors_1.next()) {
                        var sector = sectors_1_1.value;
                        holder.sectors[sector] = id;
                    }
                }
                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                finally {
                    try {
                        if (sectors_1_1 && !sectors_1_1.done && (_b = sectors_1.return)) _b.call(sectors_1);
                    }
                    finally { if (e_5) throw e_5.error; }
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return holder;
    };
    /**
     * @param {?} file
     * @return {?}
     */
    FileParserHelperService.prototype.parseSectionInAreasFromFile = /**
     * @param {?} file
     * @return {?}
     */
    function (file) {
        if (!file) {
            return of(false);
        }
        return this.http.get(file).pipe(map(this.prepareSectionInAreas), map(this.parseSectionInAreas));
    };
    /* Parse area names prepare and merge*/
    /* Parse area names prepare and merge*/
    /**
     * @protected
     * @param {?} areaNames
     * @return {?}
     */
    FileParserHelperService.prototype.prepareAreaNames = /* Parse area names prepare and merge*/
    /**
     * @protected
     * @param {?} areaNames
     * @return {?}
     */
    function (areaNames) {
        return (/** @type {?} */ (areaNames));
    };
    /**
     * @protected
     * @param {?} idTranslatorHolder
     * @param {?} areaNames
     * @return {?}
     */
    FileParserHelperService.prototype.mergeAreaNames = /**
     * @protected
     * @param {?} idTranslatorHolder
     * @param {?} areaNames
     * @return {?}
     */
    function (idTranslatorHolder, areaNames) {
        var e_6, _a;
        try {
            for (var _b = __values(Object.entries(areaNames)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), area = _d[0], name_1 = _d[1];
                try {
                    idTranslatorHolder.frommmc.areas[area].name = name_1;
                }
                catch (e) {
                    console.warn(e);
                }
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_6) throw e_6.error; }
        }
        return idTranslatorHolder;
    };
    /**
     * @protected
     * @param {?} file
     * @return {?}
     */
    FileParserHelperService.prototype.parseAreaNamesFromFile = /**
     * @protected
     * @param {?} file
     * @return {?}
     */
    function (file) {
        if (!file) {
            return of(false);
        }
        return this.http.get(file).pipe(map(this.prepareAreaNames));
    };
    /* parse area description: prepare, parse and merge */
    /* parse area description: prepare, parse and merge */
    /**
     * @protected
     * @param {?} data
     * @return {?}
     */
    FileParserHelperService.prototype.prepareAreaDescription = /* parse area description: prepare, parse and merge */
    /**
     * @protected
     * @param {?} data
     * @return {?}
     */
    function (data) {
        return (/** @type {?} */ (data));
    };
    /* https://www.csvjson.com/csv2json */
    /* https://www.csvjson.com/csv2json */
    /**
     * @protected
     * @param {?} data
     * @return {?}
     */
    FileParserHelperService.prototype.parseAreaDescription = /* https://www.csvjson.com/csv2json */
    /**
     * @protected
     * @param {?} data
     * @return {?}
     */
    function (data) {
        var e_7, _a;
        /** @type {?} */
        var returnObject = {};
        try {
            for (var _b = __values((/** @type {?} */ (data))), _c = _b.next(); !_c.done; _c = _b.next()) {
                var descriptionItem = _c.value;
                /** @type {?} */
                var sector = descriptionItem.sector;
                /** @type {?} */
                var description = descriptionItem.description;
                if (!returnObject[sector]) {
                    returnObject[sector] = [];
                }
                if (returnObject[sector].indexOf(description) === -1) {
                    returnObject[sector].push(description);
                }
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_7) throw e_7.error; }
        }
        return returnObject;
    };
    // tslint:disable-next-line max-line-length
    // tslint:disable-next-line max-line-length
    /**
     * @protected
     * @param {?} holder
     * @param {?} areaDescription
     * @param {?} sectorInAreas
     * @return {?}
     */
    FileParserHelperService.prototype.mergeAreaDescription = 
    // tslint:disable-next-line max-line-length
    /**
     * @protected
     * @param {?} holder
     * @param {?} areaDescription
     * @param {?} sectorInAreas
     * @return {?}
     */
    function (holder, areaDescription, sectorInAreas) {
        var e_8, _a;
        try {
            for (var _b = __values(Object.entries(areaDescription)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), sectorId = _d[0], description = _d[1];
                /** @type {?} */
                var areaId = sectorInAreas ? sectorInAreas['sectors'][sectorId] : sectorId;
                try {
                    holder.frommmc.areas[areaId].description = description;
                }
                catch (e) {
                    console.warn(e);
                    console.warn(sectorId);
                }
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_8) throw e_8.error; }
        }
        return holder;
    };
    /**
     * @protected
     * @param {?} file
     * @return {?}
     */
    FileParserHelperService.prototype.parseAreaDescriptionFromFile = /**
     * @protected
     * @param {?} file
     * @return {?}
     */
    function (file) {
        if (!file) {
            return of(false);
        }
        return this.http.get(file).pipe(map(this.prepareAreaDescription), map(this.parseAreaDescription));
    };
    /* all parsing*/
    // tslint:disable-next-line max-line-length
    /* all parsing*/
    // tslint:disable-next-line max-line-length
    /**
     * @private
     * @param {?} data
     * @return {?}
     */
    FileParserHelperService.prototype.mergeParsing = /* all parsing*/
    // tslint:disable-next-line max-line-length
    /**
     * @private
     * @param {?} data
     * @return {?}
     */
    function (data // section in areas
    ) {
        /** @type {?} */
        var holder = data[0];
        /** @type {?} */
        var areaNames = data[1];
        /** @type {?} */
        var areaDescription = data[2];
        /** @type {?} */
        var sectorInAreas = data[3];
        if (areaNames) {
            holder = this.mergeAreaNames(holder, (/** @type {?} */ (areaNames)));
        }
        if (areaDescription) {
            // tslint:disable-next-line max-line-length
            holder = this.mergeAreaDescription(holder, (/** @type {?} */ (areaDescription)), (/** @type {?} */ (sectorInAreas)));
        }
        return { normal: holder, multiple: sectorInAreas };
    };
    /**
     * @param {?} configuration
     * @return {?}
     */
    FileParserHelperService.prototype.parseFromFiles = /**
     * @param {?} configuration
     * @return {?}
     */
    function (configuration) {
        var _this = this;
        var e_9, _a;
        if (configuration.baseUrl) {
            try {
                for (var _b = __values(Object.keys(configuration.paths)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var keyPath = _c.value;
                    configuration.paths[keyPath] = configuration.baseUrl + configuration.paths[keyPath];
                }
            }
            catch (e_9_1) { e_9 = { error: e_9_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_9) throw e_9.error; }
            }
        }
        /** @type {?} */
        var files = configuration.paths;
        /** @type {?} */
        var data = forkJoin(this.parseAreasAndSeats(files.areaMapping, files.seats), this.parseAreaNamesFromFile(files.areaNames), this.parseAreaDescriptionFromFile(files.areaDescriptions), this.parseSectionInAreasFromFile(files.sectionsInAreas));
        return data.pipe(map((/**
         * @param {?} parsedData
         * @return {?}
         */
        function (parsedData) { return _this.mergeParsing(parsedData); })), tap((/**
         * @param {?} text
         * @return {?}
         */
        function (text) {
            if (configuration.local) {
                console.log(text);
            }
        })));
    };
    FileParserHelperService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    FileParserHelperService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    /** @nocollapse */ FileParserHelperService.ngInjectableDef = defineInjectable({ factory: function FileParserHelperService_Factory() { return new FileParserHelperService(inject(HttpClient)); }, token: FileParserHelperService, providedIn: "root" });
    return FileParserHelperService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SeatgeekConnectionIdtranslatorService = /** @class */ (function () {
    function SeatgeekConnectionIdtranslatorService(config, http, fileParser) {
        var _this = this;
        this.config = config;
        this.http = http;
        this.fileParser = fileParser;
        this._translationsHolder = new AsyncSubject();
        this._sectionInAreasHolder = new AsyncSubject();
        // TODO construct also with injection tokens for seats, areas...
        // Construction with file gets
        if (config.idTranslationFromFiles) {
            this.fileParser.parseFromFiles(config.dataConfig).subscribe((/**
             * @param {?} data
             * @return {?}
             */
            function (data) {
                if (config.dataConfig.local) { // todo test others
                    _this.propagateAreaIds(data.normal);
                    _this.propagateSectionInAreas(data.multiple);
                }
            }));
        }
    }
    /**
     * @private
     * @param {?} ids
     * @return {?}
     */
    SeatgeekConnectionIdtranslatorService.prototype.propagateAreaIds = /**
     * @private
     * @param {?} ids
     * @return {?}
     */
    function (ids) {
        this._translationsHolder.next(ids);
        this._translationsHolder.complete();
    };
    /**
     * @private
     * @param {?} ids
     * @return {?}
     */
    SeatgeekConnectionIdtranslatorService.prototype.propagateSectionInAreas = /**
     * @private
     * @param {?} ids
     * @return {?}
     */
    function (ids) {
        this._sectionInAreasHolder.next(ids);
        this._sectionInAreasHolder.complete();
    };
    Object.defineProperty(SeatgeekConnectionIdtranslatorService.prototype, "translationsHolder", {
        get: /**
         * @return {?}
         */
        function () {
            return this._translationsHolder.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SeatgeekConnectionIdtranslatorService.prototype, "sectionsInAreas", {
        get: /**
         * @return {?}
         */
        function () {
            return this._sectionInAreasHolder.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    SeatgeekConnectionIdtranslatorService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    SeatgeekConnectionIdtranslatorService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [SEATGEEK_CONNECTION_CONFIG,] }] },
        { type: HttpClient },
        { type: FileParserHelperService }
    ]; };
    /** @nocollapse */ SeatgeekConnectionIdtranslatorService.ngInjectableDef = defineInjectable({ factory: function SeatgeekConnectionIdtranslatorService_Factory() { return new SeatgeekConnectionIdtranslatorService(inject(SEATGEEK_CONNECTION_CONFIG), inject(HttpClient), inject(FileParserHelperService)); }, token: SeatgeekConnectionIdtranslatorService, providedIn: "root" });
    return SeatgeekConnectionIdtranslatorService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var JsonXmlTranslatorService = /** @class */ (function () {
    function JsonXmlTranslatorService() {
    }
    /*public json2xml(o, tab) {
      const toXml = function (v, name, ind) {
        let xml = '';
        if (v instanceof Array) {
          for (let i = 0, n = v.length; i < n; i++) {
            xml += ind + toXml(v[i], name, ind + '\t') + '\n';
          }
        } else if (typeof(v) === 'object') {
          let hasChild = false;
          xml += ind + '<' + name;
          for (const m in v) {
            if (m.charAt(0) === '@') {
              xml += ' ' + m.substr(1) + '="' + v[m].toString() + '"';
            } else {
              hasChild = true;
            }
          }
          xml += hasChild ? '>' : '/>';
          if (hasChild) {
            for (const m in v) {
              if (m === '#text') {
                xml += v[m];
              } else if (m === '#cdata') {
                xml += '<![CDATA[' + v[m] + ']]>';
                   } else if (m.charAt(0) !== '@') {
                xml += toXml(v[m], m, ind + '\t');
                   }
            }
            xml += (xml.charAt(xml.length - 1) === '\n' ? ind : '') + '</' + name + '>';
          }
        } else {
          xml += ind + '<' + name + '>' + v['toString']() + '</' + name + '>';
        }
        return xml;
      }, xml = '';
      for (const m in o) {
        xml += toXml(o[m], m, '');
      }
      return tab ? xml.replace(/\t/g, tab) : xml.replace(/\t|\n/g, '');
    }*/
    /*public json2xml(o, tab) {
        const toXml = function (v, name, ind) {
          let xml = '';
          if (v instanceof Array) {
            for (let i = 0, n = v.length; i < n; i++) {
              xml += ind + toXml(v[i], name, ind + '\t') + '\n';
            }
          } else if (typeof(v) === 'object') {
            let hasChild = false;
            xml += ind + '<' + name;
            for (const m in v) {
              if (m.charAt(0) === '@') {
                xml += ' ' + m.substr(1) + '="' + v[m].toString() + '"';
              } else {
                hasChild = true;
              }
            }
            xml += hasChild ? '>' : '/>';
            if (hasChild) {
              for (const m in v) {
                if (m === '#text') {
                  xml += v[m];
                } else if (m === '#cdata') {
                  xml += '<![CDATA[' + v[m] + ']]>';
                     } else if (m.charAt(0) !== '@') {
                  xml += toXml(v[m], m, ind + '\t');
                     }
              }
              xml += (xml.charAt(xml.length - 1) === '\n' ? ind : '') + '</' + name + '>';
            }
          } else {
            xml += ind + '<' + name + '>' + v['toString']() + '</' + name + '>';
          }
          return xml;
        }, xml = '';
        for (const m in o) {
          xml += toXml(o[m], m, '');
        }
        return tab ? xml.replace(/\t/g, tab) : xml.replace(/\t|\n/g, '');
      }*/
    /**
     * @private
     * @param {?} xml
     * @return {?}
     */
    JsonXmlTranslatorService.prototype.parseXml = /*public json2xml(o, tab) {
        const toXml = function (v, name, ind) {
          let xml = '';
          if (v instanceof Array) {
            for (let i = 0, n = v.length; i < n; i++) {
              xml += ind + toXml(v[i], name, ind + '\t') + '\n';
            }
          } else if (typeof(v) === 'object') {
            let hasChild = false;
            xml += ind + '<' + name;
            for (const m in v) {
              if (m.charAt(0) === '@') {
                xml += ' ' + m.substr(1) + '="' + v[m].toString() + '"';
              } else {
                hasChild = true;
              }
            }
            xml += hasChild ? '>' : '/>';
            if (hasChild) {
              for (const m in v) {
                if (m === '#text') {
                  xml += v[m];
                } else if (m === '#cdata') {
                  xml += '<![CDATA[' + v[m] + ']]>';
                     } else if (m.charAt(0) !== '@') {
                  xml += toXml(v[m], m, ind + '\t');
                     }
              }
              xml += (xml.charAt(xml.length - 1) === '\n' ? ind : '') + '</' + name + '>';
            }
          } else {
            xml += ind + '<' + name + '>' + v['toString']() + '</' + name + '>';
          }
          return xml;
        }, xml = '';
        for (const m in o) {
          xml += toXml(o[m], m, '');
        }
        return tab ? xml.replace(/\t/g, tab) : xml.replace(/\t|\n/g, '');
      }*/
    /**
     * @private
     * @param {?} xml
     * @return {?}
     */
    function (xml) {
        /** @type {?} */
        var dom = null;
        if (window['DOMParser']) {
            try {
                dom = (new DOMParser()).parseFromString(xml, 'text/xml');
            }
            catch (e) {
                dom = null;
            }
        }
        else if (window['ActiveXObject']) {
            try {
                dom = new window['ActiveXObject']('Microsoft.XMLDOM');
                dom.async = false;
                if (!dom.loadXML(xml)) { // parse error ..
                    window.alert(dom.parseError.reason + dom.parseError.srcText);
                }
            }
            catch (e) {
                dom = null;
            }
        }
        else {
            alert('oops');
        }
        return dom;
    };
    /**
     * @param {?} xml
     * @param {?} tab
     * @return {?}
     */
    JsonXmlTranslatorService.prototype.xml2json = /**
     * @param {?} xml
     * @param {?} tab
     * @return {?}
     */
    function (xml, tab) {
        xml = this.parseXml(xml);
        /** @type {?} */
        var X = {
            toObj: (/**
             * @param {?} xml
             * @return {?}
             */
            function (xml) {
                /** @type {?} */
                var o = {};
                if (xml.nodeType === 1) { // element node ..
                    if (xml.attributes.length) { // element with attributes  ..
                        for (var i = 0; i < xml.attributes.length; i++) {
                            o['@' + xml.attributes[i].nodeName] = (xml.attributes[i].nodeValue || '').toString();
                        }
                    }
                    if (xml.firstChild) { // element has child nodes ..
                        // element has child nodes ..
                        /** @type {?} */
                        var textChild = 0;
                        /** @type {?} */
                        var cdataChild = 0;
                        /** @type {?} */
                        var hasElementChild = false;
                        for (var n = xml.firstChild; n; n = n.nextSibling) {
                            if (n.nodeType === 1) {
                                hasElementChild = true;
                            }
                            else if (n.nodeType === 3 && n.nodeValue.match(/[^ \f\n\r\t\v]/)) {
                                textChild++;
                            }
                            else if (n.nodeType === 4) {
                                cdataChild++;
                            } // cdata section node
                        }
                        if (hasElementChild) {
                            if (textChild < 2 && cdataChild < 2) { // structured element with evtl. a single text or/and cdata node ..
                                X.removeWhite(xml);
                                for (var n = xml.firstChild; n; n = n.nextSibling) {
                                    if (n.nodeType === 3) { // text node
                                        o['#text'] = X.escape(n.nodeValue);
                                    }
                                    else if (n.nodeType === 4) { // cdata node
                                        o['#cdata'] = X.escape(n.nodeValue);
                                    }
                                    else if (o[n.nodeName]) { // multiple occurence of element ..
                                        if (o[n.nodeName] instanceof Array) {
                                            o[n.nodeName][o[n.nodeName].length] = X.toObj(n);
                                        }
                                        else {
                                            o[n.nodeName] = [o[n.nodeName], X.toObj(n)];
                                        }
                                    }
                                    else { // first occurence of element..
                                        o[n.nodeName] = X.toObj(n);
                                    }
                                }
                            }
                            else { // mixed content
                                if (!xml.attributes.length) {
                                    o = X.escape(X.innerXml(xml));
                                }
                                else {
                                    o['#text'] = X.escape(X.innerXml(xml));
                                }
                            }
                        }
                        else if (textChild) { // pure text
                            if (!xml.attributes.length) {
                                o = X.escape(X.innerXml(xml));
                            }
                            else {
                                o['#text'] = X.escape(X.innerXml(xml));
                            }
                        }
                        else if (cdataChild) { // cdata
                            if (cdataChild > 1) {
                                o = X.escape(X.innerXml(xml));
                            }
                            else {
                                for (var n = xml.firstChild; n; n = n.nextSibling) {
                                    o['#cdata'] = X.escape(n.nodeValue);
                                }
                            }
                        }
                    }
                    if (!xml.attributes.length && !xml.firstChild) {
                        o = null;
                    }
                }
                else if (xml.nodeType === 9) { // document.node
                    o = X.toObj(xml.documentElement);
                }
                else {
                    alert('unhandled node type: ' + xml.nodeType);
                }
                return o;
            }),
            toJson: (/**
             * @param {?} o
             * @param {?} name
             * @param {?} ind
             * @return {?}
             */
            function (o, name, ind) {
                /** @type {?} */
                var json = name ? ('"' + name + '"') : '';
                if (o instanceof Array) {
                    for (var i = 0, n = o.length; i < n; i++) {
                        o[i] = X.toJson(o[i], '', ind + '\t');
                    }
                    json += (name ? ':[' : '[') + (o.length > 1 ? ('\n' + ind + '\t' + o.join(',\n' + ind + '\t') + '\n' + ind) : o.join('')) + ']';
                }
                else if (o === null) {
                    json += (name && ':') + 'null';
                }
                else if (typeof (o) === 'object') {
                    /** @type {?} */
                    var arr = [];
                    for (var m in o) {
                        arr[arr.length] = X.toJson(o[m], m, ind + '\t');
                    }
                    json += (name ? ':{' : '{') + (arr.length > 1 ? ('\n' + ind + '\t' + arr.join(',\n' + ind + '\t') + '\n' + ind) : arr.join('')) + '}';
                }
                else if (typeof (o) === 'string') {
                    json += (name && ':') + '"' + o.toString() + '"';
                }
                else {
                    json += (name && ':') + o.toString();
                }
                return json;
            }),
            innerXml: (/**
             * @param {?} node
             * @return {?}
             */
            function (node) {
                /** @type {?} */
                var s = '';
                if ('innerHTML' in node) {
                    s = node.innerHTML;
                }
                else {
                    /** @type {?} */
                    var asXml_1 = (/**
                     * @param {?} n
                     * @return {?}
                     */
                    function (n) {
                        /** @type {?} */
                        var s = '';
                        if (n.nodeType === 1) {
                            s += '<' + n.nodeName;
                            for (var i = 0; i < n.attributes.length; i++) {
                                s += ' ' + n.attributes[i].nodeName + '="' + (n.attributes[i].nodeValue || '').toString() + '"';
                            }
                            if (n.firstChild) {
                                s += '>';
                                for (var c = n.firstChild; c; c = c.nextSibling) {
                                    s += asXml_1(c);
                                }
                                s += '</' + n.nodeName + '>';
                            }
                            else {
                                s += '/>';
                            }
                        }
                        else if (n.nodeType === 3) {
                            s += n.nodeValue;
                        }
                        else if (n.nodeType === 4) {
                            s += '<![CDATA[' + n.nodeValue + ']]>';
                        }
                        return s;
                    });
                    for (var c = node.firstChild; c; c = c.nextSibling) {
                        s += asXml_1(c);
                    }
                }
                return s;
            }),
            escape: (/**
             * @param {?} txt
             * @return {?}
             */
            function (txt) {
                return txt.replace(/[\\]/g, '\\\\')
                    .replace(/[\"]/g, '\\"')
                    .replace(/[\n]/g, '\\n')
                    .replace(/[\r]/g, '\\r');
            }),
            removeWhite: (/**
             * @param {?} e
             * @return {?}
             */
            function (e) {
                e.normalize();
                for (var n = e.firstChild; n;) {
                    if (n.nodeType === 3) { // text node
                        if (!n.nodeValue.match(/[^ \f\n\r\t\v]/)) { // pure whitespace text node
                            // pure whitespace text node
                            /** @type {?} */
                            var nxt = n.nextSibling;
                            e.removeChild(n);
                            n = nxt;
                        }
                        else {
                            n = n.nextSibling;
                        }
                    }
                    else if (n.nodeType === 1) { // element node
                        X.removeWhite(n);
                        n = n.nextSibling;
                    }
                    else { // any other node
                        n = n.nextSibling;
                    }
                }
                return e;
            })
        };
        if (xml.nodeType === 9) { // document node
            xml = xml.documentElement;
        }
        /** @type {?} */
        var json = X.toJson(X.toObj(X.removeWhite(xml)), xml.nodeName, '\t');
        return '{\n' + tab + (tab ? json.replace(/\t/g, tab) : json.replace(/\t|\n/g, '')) + '\n}';
    };
    JsonXmlTranslatorService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    JsonXmlTranslatorService.ctorParameters = function () { return []; };
    /** @nocollapse */ JsonXmlTranslatorService.ngInjectableDef = defineInjectable({ factory: function JsonXmlTranslatorService_Factory() { return new JsonXmlTranslatorService(); }, token: JsonXmlTranslatorService, providedIn: "root" });
    return JsonXmlTranslatorService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SeatgeekConnectionSeriesService = /** @class */ (function () {
    function SeatgeekConnectionSeriesService(http, helper, translator, config) {
        var _this = this;
        this.http = http;
        this.helper = helper;
        this.translator = translator;
        this.config = config;
        this.mapXmlToJson = map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            return JSON.parse(_this.helper.xml2json(data, ' '));
        }));
        this.transactionData = new ReplaySubject(1);
        /**
         * Important example of formatting values (needs completion)
         */
        this.Basket = new ReplaySubject(1);
        this.priceTypes = null;
        console.log('series service', config);
        this.fullProxyEndpoint = this.config.proxyApiUrl + "proxy/" + this.config.seatgeekClientUrl;
    }
    Object.defineProperty(SeatgeekConnectionSeriesService.prototype, "escapedToken", {
        get: /**
         * @return {?}
         */
        function () {
            return this.token.replace(/%25/gi, '%');
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @private
     * @param {?} token
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.untokenize = /**
     * @private
     * @param {?} token
     * @return {?}
     */
    function (token) {
        var _this = this;
        return this.http.get(this.config.proxyApiUrl + 'untokenize?cart_token=' + token).pipe(tap((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            _this.transactionData.next(data);
        })));
    };
    // soap request response
    // soap request response
    /**
     * @private
     * @param {?} message
     * @param {?} action
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.doSoapQuery = 
    // soap request response
    /**
     * @private
     * @param {?} message
     * @param {?} action
     * @return {?}
     */
    function (message, action) {
        /** @type {?} */
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': "application/soap+xml;charset=UTF-8;action=\"" + action + "\"" }),
            responseType: (/** @type {?} */ ('text'))
        };
        return this.http.post(this.fullProxyEndpoint, message, httpOptions).pipe(this.mapXmlToJson);
    };
    // soap onlyresponse
    // soap onlyresponse
    /**
     * @private
     * @param {?} endpoint
     * @param {?=} params
     * @param {?=} body
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.doSoapResponseQuery = 
    // soap onlyresponse
    /**
     * @private
     * @param {?} endpoint
     * @param {?=} params
     * @param {?=} body
     * @return {?}
     */
    function (endpoint, params, body) {
        if (params === void 0) { params = null; }
        if (body === void 0) { body = null; }
        var e_1, _a;
        /** @type {?} */
        var httpOptions = {
            responseType: (/** @type {?} */ ('text'))
        };
        /** @type {?} */
        var finalUrl = "" + this.config.proxyApiUrl + endpoint + "?token=" + this.escapedToken + "&client=" + this.config.client;
        if (params) {
            try {
                for (var _b = __values(Object.entries(params)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                    finalUrl += "&" + key + "=" + value;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        /** @type {?} */
        var observable = body ? this.http.post(finalUrl, body, httpOptions) : this.http.get(finalUrl, httpOptions);
        return observable.pipe(this.mapXmlToJson);
    };
    /**
     * @private
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype._queryTransaction = /**
     * @private
     * @return {?}
     */
    function () {
        return this.doSoapResponseQuery('queryTransaction');
    };
    /**
     * @private
     * @param {?} areaid
     * @param {?} seriesid
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype._getSeriesSeatStatus = /**
     * @private
     * @param {?} areaid
     * @param {?} seriesid
     * @return {?}
     */
    function (areaid, seriesid) {
        if (areaid === 'all') {
            areaid = '00000000-0000-0000-0000-000000000000';
        }
        /** @type {?} */
        var params;
        if (seriesid == null) {
            params = { 'areaid': areaid };
        }
        else {
            params = { 'areaid': areaid, 'seriesid': seriesid };
        }
        return this.doSoapResponseQuery('getSeriesSeatStatus', params);
    };
    /**
     * @private
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype._getSubscriptionDescription = /**
     * @private
     * @return {?}
     */
    function () {
        return this.doSoapResponseQuery('getSubscriptionDescription', {});
    };
    /**
     * @private
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype._validateTransaction = /**
     * @private
     * @return {?}
     */
    function () {
        return this.doSoapResponseQuery('validateTransaction', {}, {});
    };
    /**
     * @private
     * @param {?} user_id
     * @param {?} password
     * @param {?} tenant_id
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype._connect = /**
     * @private
     * @param {?} user_id
     * @param {?} password
     * @param {?} tenant_id
     * @return {?}
     */
    function (user_id, password, tenant_id) {
        var e_2, _a;
        // complex post example tODO type
        /** @type {?} */
        var params = { 'user_id': user_id, 'password': password, 'tenant_id': tenant_id };
        /** @type {?} */
        var finalUrl = this.config.proxyApiUrl + "connect?token=" + this.token + "&client=" + this.config.client;
        if (params) {
            try {
                for (var _b = __values(Object.entries(params)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                    finalUrl += "&" + key + "=" + value;
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        return this.http.post(finalUrl, { params: params });
    };
    /**
     * @private
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype._disconnect = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var finalUrl = this.config.proxyApiUrl + "disconnect?token=" + this.token + "&client=" + this.config.client;
        return this.http.post(finalUrl, {});
    };
    /**
     * @private
     * @param {?} areaid
     * @param {?} pricetype
     * @param {?} seats
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype._addSubscriptionsToBasket = /**
     * @private
     * @param {?} areaid
     * @param {?} pricetype
     * @param {?} seats
     * @return {?}
     */
    function (areaid, pricetype, seats) {
        // complex post example tODO type
        /** @type {?} */
        var body = { 'areaid': areaid, 'priceType': pricetype, 'seats': seats };
        return this.doSoapResponseQuery('addSubscriptionsToBasket', {}, body);
    };
    /**
     * @private
     * @param {?} areaid
     * @param {?} pricetype
     * @param {?} seriesid
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype._addGASubscriptionsToBasket = /**
     * @private
     * @param {?} areaid
     * @param {?} pricetype
     * @param {?} seriesid
     * @return {?}
     */
    function (areaid, pricetype, seriesid) {
        // complex post example tODO type
        /** @type {?} */
        var body;
        // pricetype = "24b6ffdf-375d-e811-811a-129dbe5738b9";
        if (seriesid == null) {
            body = { 'areaid': areaid, 'priceType': pricetype, 'seatingType': 'BestAvailable' };
            // body = {'areaid': areaid, 'priceType': pricetype};
        }
        else {
            body = { 'areaid': areaid, 'priceType': pricetype, 'seriesid': seriesid, 'seatingType': 'BestAvailable' };
            // body = {'areaid': areaid, 'priceType': pricetype, 'seriesid': seriesid};
        }
        return this.doSoapResponseQuery('addGAOrBASubscriptionsToBasket', {}, body);
    };
    /**
     * @private
     * @param {?} items
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype._discardBasketItems = /**
     * @private
     * @param {?} items
     * @return {?}
     */
    function (items) {
        // complex post example tODO type
        /** @type {?} */
        var body = { 'items': items };
        return this.doSoapResponseQuery('discardBasketItems', {}, body);
    };
    // /getCustomerExtraFields [GET]
    //   token
    //   client
    //   client_guid
    // /getCustomerExtraFields [GET]
    //   token
    //   client
    //   client_guid
    /**
     * @private
     * @param {?} client_guid
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype._getCustomerExtraFields = 
    // /getCustomerExtraFields [GET]
    //   token
    //   client
    //   client_guid
    /**
     * @private
     * @param {?} client_guid
     * @return {?}
     */
    function (client_guid) {
        /** @type {?} */
        var params;
        if (client_guid) {
            params = { 'client_guid': client_guid };
        }
        return this.doSoapResponseQuery('getCustomerExtraFields', params);
    };
    /**
     * @private
     * @param {?} data
     * @param {?} translations
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.parseItems = /**
     * @private
     * @param {?} data
     * @param {?} translations
     * @return {?}
     */
    function (data, translations) {
        var e_3, _a;
        /** @type {?} */
        var items = [];
        /** @type {?} */
        var productData;
        /** @type {?} */
        var parsedProductData;
        /** @type {?} */
        var parsedPriceType;
        if (data.Items == null) {
            return items;
        }
        if (data.Items.AbstractItem['@i:type'] != null) {
            data.Items.AbstractItem = [data.Items.AbstractItem];
        }
        try {
            for (var _b = __values(data.Items.AbstractItem), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                if (item['@i:type'] === 'SubscriptionProductItem') {
                    // PRODUCT DATA
                    productData = item['ProductData'];
                    parsedProductData = {};
                    /** @type {?} */
                    var sectorName = void 0;
                    if (productData['em:SectorName'] != null && productData['em:RowName'] != null &&
                        productData['em:SeatName'] != null && productData['em:SeatingType'] !== 'GeneralAdmission') {
                        if (['1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(productData['em:SectorName'].replace(' ', ''))) {
                            sectorName = '0' + productData['em:SectorName'].replace(' ', '');
                        }
                        else {
                            sectorName = productData['em:SectorName'].replace(' ', '');
                        }
                        parsedProductData.section = sectorName;
                        parsedProductData.row = productData['em:RowName'];
                        parsedProductData.seat = productData['em:SeatName'];
                        parsedProductData.mmcSeatId = 'S_' + sectorName + '-' +
                            productData['em:RowName'] + '-' + productData['em:SeatName'];
                    }
                    else {
                        parsedProductData.mmcSeatId = 'GeneralAdmission';
                    }
                    parsedProductData.areaid = productData['em:AreaId'];
                    parsedProductData.area = translations['fromseatgeek']['areas'][productData['em:AreaId'].toUpperCase()];
                    // PRICE TYPE
                    parsedPriceType = {};
                    parsedPriceType.id = item['PriceTypeId'];
                    parsedPriceType.name = item['PriceTypeName'];
                    /** @type {?} */
                    var parsedItem = {
                        id: item.ItemId,
                        price: parseFloat(item.TotalPrice['tf:Amount']),
                        action: productData['em:Action'],
                        insertionMode: item['InsertionMode'],
                        productData: parsedProductData,
                        priceType: parsedPriceType,
                    };
                    /** @type {?} */
                    var substitutes = item["SubstitutedForItemId"];
                    if (substitutes) {
                        parsedItem.SubstitutedForItemId = item["SubstitutedForItemId"];
                    }
                    items.push(parsedItem);
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return items;
    };
    /**
     * @param {?} token
     * @param {?=} initUntokenize
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.init = /**
     * @param {?} token
     * @param {?=} initUntokenize
     * @return {?}
     */
    function (token, initUntokenize) {
        if (initUntokenize === void 0) { initUntokenize = false; }
        this.token = token;
        if (initUntokenize) {
            this.untokenize(token).subscribe();
        }
    };
    /**
     * Simple method
     * 1st we create the interfaces for total response and body: SeatgeekQueryTransactionResponseBody, SeatgeekQueryTransactionResponse
     * 2nd we create the method that does only the raw request: _queryTransaction (api names and parameters in
     *      https://bitbucket.org/mmc-istari/seatgeek-internal-2018-serverless-proxy-api/src/master/api_description.txt)
     *      token and client are automatically added
     * 3rd  we create the interface with the desired shape and adapt the data: SeatgeekTransaction, queryTransaction
     */
    /**
     * Simple method
     * 1st we create the interfaces for total response and body: SeatgeekQueryTransactionResponseBody, SeatgeekQueryTransactionResponse
     * 2nd we create the method that does only the raw request: _queryTransaction (api names and parameters in
     *      https://bitbucket.org/mmc-istari/seatgeek-internal-2018-serverless-proxy-api/src/master/api_description.txt)
     *      token and client are automatically added
     * 3rd  we create the interface with the desired shape and adapt the data: SeatgeekTransaction, queryTransaction
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.queryTransaction = /**
     * Simple method
     * 1st we create the interfaces for total response and body: SeatgeekQueryTransactionResponseBody, SeatgeekQueryTransactionResponse
     * 2nd we create the method that does only the raw request: _queryTransaction (api names and parameters in
     *      https://bitbucket.org/mmc-istari/seatgeek-internal-2018-serverless-proxy-api/src/master/api_description.txt)
     *      token and client are automatically added
     * 3rd  we create the interface with the desired shape and adapt the data: SeatgeekTransaction, queryTransaction
     * @return {?}
     */
    function () {
        return this._queryTransaction().pipe(map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            // the parsing method is done here to adapt the data
            /** @type {?} */
            var messageBody = data['s:Envelope']['s:Body'];
            if (messageBody['s:Fault'] != null) {
                /** @type {?} */
                var errorMessage = messageBody['s:Fault']['s:Code']['s:Value'];
                console.log(errorMessage);
                throw new Error(errorMessage);
            }
            else {
                return messageBody.ISaleFacade_QueryTransaction_ResponseMsg.TransactionSnapshot;
            }
        })));
    };
    /**
     * In this case we are chaining to queryTransaction method and returning raw seatgeek basket
     */
    /**
     * In this case we are chaining to queryTransaction method and returning raw seatgeek basket
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.getBasket = /**
     * In this case we are chaining to queryTransaction method and returning raw seatgeek basket
     * @return {?}
     */
    function () {
        return this.queryTransaction().pipe(map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data == null) {
                return null;
            }
            else {
                return data.Basket;
            }
        })));
    };
    /**
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.getCurrentSeats = /**
     * @return {?}
     */
    function () {
        this.Basket.subscribe((/**
         * @param {?} currentBasket
         * @return {?}
         */
        function (currentBasket) {
            /** @type {?} */
            var currentSeats = [];
            for (var i = 0; i < currentBasket.length; ++i) {
                currentSeats.push(currentBasket[i]['productData']['mmcSeatId']);
            }
            return currentSeats;
        }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            return null;
        }));
    };
    /**
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.getCurrentPriceTypes = /**
     * @return {?}
     */
    function () {
        return this.priceTypes;
    };
    /**
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.getSubscriptionData = /**
     * @return {?}
     */
    function () {
        var _this = this;
        return this._getSubscriptionDescription().pipe(map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data == null) {
                // this.priceTypes;
                return null;
            }
            else {
                /** @type {?} */
                var messageBody = data['s:Envelope']['s:Body'];
                console.log(messageBody);
                if (messageBody['s:Fault'] != null) {
                    /** @type {?} */
                    var errorMessage = messageBody['s:Fault']['s:Code']['s:Value'];
                    console.log(errorMessage);
                    throw new Error(errorMessage);
                }
                else {
                    /** @type {?} */
                    var pricetypes = data['s:Envelope']['s:Body']['ISubscriptionFacade_GetSubscriptionDescription_ResponseMsg']['PricingDescription']['AxisDescriptions']['ProductPriceAxisDescription'][0]['Values'];
                    if (pricetypes[0] == null) {
                        _this.priceTypes = [pricetypes['b:KeyValuePairOfguidstring']];
                        if (pricetypes['b:KeyValuePairOfguidstring'][0] == null) {
                            pricetypes = [pricetypes['b:KeyValuePairOfguidstring']];
                        }
                        else {
                            pricetypes = pricetypes['b:KeyValuePairOfguidstring'];
                        }
                    }
                    _this.priceTypes = pricetypes;
                    /** @type {?} */
                    var productDescription = data['s:Envelope']['s:Body']['ISubscriptionFacade_GetSubscriptionDescription_ResponseMsg']['ProductDescription'];
                    return { pricetypes: pricetypes, productDescription: productDescription };
                }
            }
        })));
    };
    /**
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.getSubscriptionID = /**
     * @return {?}
     */
    function () {
        return this.getSubscriptionData().pipe(map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            return data['em:Id'];
        })));
    };
    /**
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.getPriceTypes = /**
     * @return {?}
     */
    function () {
        var _this = this;
        return this._getSubscriptionDescription().pipe(map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data == null) {
                // this.priceTypes;
                return null;
            }
            else {
                console.log(data['s:Envelope']['s:Body']);
                /** @type {?} */
                var pricetypes = data['s:Envelope']['s:Body']['ISubscriptionFacade_GetSubscriptionDescription_ResponseMsg']['PricingDescription']['AxisDescriptions']['ProductPriceAxisDescription'][0]['Values'];
                if (pricetypes[0] == null) {
                    _this.priceTypes = [pricetypes['b:KeyValuePairOfguidstring']];
                    if (pricetypes['b:KeyValuePairOfguidstring'][0] == null) {
                        return [pricetypes['b:KeyValuePairOfguidstring']];
                    }
                    else {
                        return pricetypes['b:KeyValuePairOfguidstring'];
                    }
                }
                _this.priceTypes = pricetypes;
                return pricetypes;
            }
        })));
    };
    /**
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.getBasketItems = /**
     * @return {?}
     */
    function () {
        var _this = this;
        return this.getBasket().pipe(map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data == null) {
                _this.Basket.next(null);
                return null;
            }
            else {
                /** @type {?} */
                var translations_1;
                _this.translator.translationsHolder.subscribe((/**
                 * @param {?} translationsHolderData
                 * @return {?}
                 */
                function (translationsHolderData) {
                    translations_1 = translationsHolderData;
                }));
                /** @type {?} */
                var items = _this.parseItems(data, translations_1);
                _this.Basket.next(items);
                return items;
            }
        }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            throw new Error(error.message);
        })));
    };
    /**
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.getGeneralAvailability = /**
     * @return {?}
     */
    function () {
        var _this = this;
        return this._getSeriesSeatStatus('all', null).pipe(map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            // the parsing method is done here to adapt the data
            /** @type {?} */
            var messageBody = data['s:Envelope']['s:Body'];
            console.log(messageBody);
            if (messageBody['s:Fault'] != null) {
                /** @type {?} */
                var errorMessage = messageBody['s:Fault']['s:Code']['s:Value'];
                console.log(errorMessage);
                throw new Error(errorMessage);
            }
            else {
                /** @type {?} */
                var sectionsRaw = messageBody['ITicketingFacade_GetSeriesSeatStatus_ResponseMsg']['SeatStatuses']['b:KeyValueOfguidAreaStatusInformationhpjoQDea'];
                /** @type {?} */
                var sectionsMMCID_1 = Array();
                /** @type {?} */
                var sectionsSGID_1 = Array();
                for (var i = 0; i < sectionsRaw.length; ++i) {
                    if (sectionsRaw[i]['b:Value']['Capacity']['IsSoldOut'] === 'false' && sectionsRaw[i]['b:Value']['Capacity']['Available'] !== '0') {
                        sectionsSGID_1.push(sectionsRaw[i]['b:Key'].toUpperCase());
                    }
                }
                _this.translator.translationsHolder.subscribe((/**
                 * @param {?} translationsHolderData
                 * @return {?}
                 */
                function (translationsHolderData) {
                    /** @type {?} */
                    var sgAreas = translationsHolderData['fromseatgeek']['areas'];
                    for (var i = 0; i < sectionsSGID_1.length; ++i) {
                        if (sgAreas[sectionsSGID_1[i]] != null) {
                            sectionsMMCID_1.push(sgAreas[sectionsSGID_1[i]]);
                        }
                    }
                }));
                return sectionsMMCID_1; // complete
            }
        })));
    };
    /**
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.getAreaAvailableSeatsCount = /**
     * @return {?}
     */
    function () {
        var _this = this;
        return this._getSeriesSeatStatus('all', null).pipe(map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            // the parsing method is done here to adapt the data
            /** @type {?} */
            var messageBody = data['s:Envelope']['s:Body'];
            if (messageBody['s:Fault'] != null) {
                /** @type {?} */
                var errorMessage = messageBody['s:Fault']['s:Code']['s:Value'];
                console.log(errorMessage);
                throw new Error(errorMessage);
            }
            else {
                /** @type {?} */
                var sectionsRaw_1 = messageBody['ITicketingFacade_GetSeriesSeatStatus_ResponseMsg']['SeatStatuses']['b:KeyValueOfguidAreaStatusInformationhpjoQDea'];
                /** @type {?} */
                var availableSeatsCount_1 = {};
                _this.translator.translationsHolder.subscribe((/**
                 * @param {?} translationsHolderData
                 * @return {?}
                 */
                function (translationsHolderData) {
                    /** @type {?} */
                    var sgAreas = translationsHolderData['fromseatgeek']['areas'];
                    for (var i = 0; i < sectionsRaw_1.length; ++i) {
                        availableSeatsCount_1[sgAreas[sectionsRaw_1[i]['b:Key'].toUpperCase()]] =
                            sectionsRaw_1[i]['b:Value']['Capacity']['Available'];
                    }
                }));
                _this.availableSeatsCount = availableSeatsCount_1; // complete
            }
        })));
    };
    /**
     * @param {?} app_config
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.getParkingGeneralAvailability = /**
     * @param {?} app_config
     * @return {?}
     */
    function (app_config) {
        return this._getSeriesSeatStatus('all', app_config.parkingConfiguration.parkingSeriesID).pipe(map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            // the parsing method is done here to adapt the data
            /** @type {?} */
            var messageBody = data['s:Envelope']['s:Body'];
            if (messageBody['s:Fault'] != null) {
                /** @type {?} */
                var errorMessage = messageBody['s:Fault']['s:Code']['s:Value'];
                console.log(errorMessage);
                throw new Error(errorMessage);
            }
            else {
                /** @type {?} */
                var sectionsRaw = messageBody['ITicketingFacade_GetSeriesSeatStatus_ResponseMsg']['SeatStatuses']['b:KeyValueOfguidAreaStatusInformationhpjoQDea'];
                /** @type {?} */
                var sectionsSGID = Array();
                for (var i = 0; i < sectionsRaw.length; ++i) {
                    if (sectionsRaw[i]['b:Value']['Capacity']['IsSoldOut'] === 'false' && sectionsRaw[i]['b:Value']['Capacity']['Available'] !== '0' &&
                        app_config.parkingConfiguration.parkingTranslation[sectionsRaw[i]['b:Key']] != null) {
                        sectionsSGID.push([sectionsRaw[i]['b:Key'],
                            app_config.parkingConfiguration.parkingTranslation[sectionsRaw[i]['b:Key']]]);
                    }
                }
                return sectionsSGID;
            }
        })));
    };
    /**
     * @param {?} areaid
     * @param {?} app_config
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.addGAParkingToBasket = /**
     * @param {?} areaid
     * @param {?} app_config
     * @return {?}
     */
    function (areaid, app_config) {
        return this._addGASubscriptionsToBasket(areaid, app_config.parkingConfiguration.parkingPricetype, app_config.parkingConfiguration.parkingSeriesID).pipe(map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            // the parsing method is done here to adapt the data
            console.log(data);
            return data;
        })));
    };
    /**
     * @param {?} sectorId
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.getAreaAvailability = /**
     * @param {?} sectorId
     * @return {?}
     */
    function (sectorId) {
        var _this = this;
        return this._getSeriesSeatStatus(sectorId, null).pipe(map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            // the parsing method is done here to adapt the data
            /** @type {?} */
            var messageBody = data['s:Envelope']['s:Body'];
            if (messageBody['s:Fault'] != null) {
                /** @type {?} */
                var errorMessage = messageBody['s:Fault']['s:Code']['s:Value'];
                console.log(errorMessage);
                throw new Error(errorMessage);
            }
            else {
                /** @type {?} */
                var sectionsRaw = messageBody['ITicketingFacade_GetSeriesSeatStatus_ResponseMsg']['SeatStatuses']['b:KeyValueOfguidAreaStatusInformationhpjoQDea'];
                /** @type {?} */
                var seatsRaw_1 = Array();
                for (var i = 0; i < sectionsRaw.length; ++i) {
                    if (sectionsRaw[i]['b:Key'].toUpperCase() === sectorId) {
                        seatsRaw_1 = sectionsRaw[i]['b:Value']['Seats']['b:KeyValueOfintSeatStatusInformationvEzo7Bse'];
                    }
                }
                /** @type {?} */
                var seatsMMCID_1 = [];
                _this.translator.translationsHolder.subscribe((/**
                 * @param {?} translationsHolderData
                 * @return {?}
                 */
                function (translationsHolderData) {
                    /** @type {?} */
                    var seatsTranslation = translationsHolderData.frommmc.areas[translationsHolderData.fromseatgeek.areas[sectorId]].seats;
                    for (var i = 0; i < seatsRaw_1.length; ++i) {
                        if (seatsRaw_1[i]['b:Value']['Availability'] === 'Available') {
                            seatsMMCID_1.push(seatsTranslation[seatsRaw_1[i]['b:Key'].toUpperCase()]);
                        }
                    }
                }));
                return seatsMMCID_1; // complete
            }
        })));
    };
    /**
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.validateTransaction = /**
     * @return {?}
     */
    function () {
        return this._validateTransaction().pipe(map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            // the parsing method is done here to adapt the data
            console.log(data);
            return data;
        })));
    };
    /**
     * @param {?} user_id
     * @param {?} password
     * @param {?} tenant_id
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.connect = /**
     * @param {?} user_id
     * @param {?} password
     * @param {?} tenant_id
     * @return {?}
     */
    function (user_id, password, tenant_id) {
        var _this = this;
        console.log('CONNECT');
        return this._connect(user_id, password, tenant_id).pipe(map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            _this.token = data.token;
            return data.token;
        })));
    };
    /**
     * @param {?} user_id
     * @param {?} password
     * @param {?} tenant_id
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.disconnect = /**
     * @param {?} user_id
     * @param {?} password
     * @param {?} tenant_id
     * @return {?}
     */
    function (user_id, password, tenant_id) {
        console.log('DISCONNECT');
        return this._disconnect().pipe(map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            console.log(data);
            return data;
        })));
    };
    /**
     * @param {?} areaid
     * @param {?} pricetype
     * @param {?} seats
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.addSubscriptionsToBasket = /**
     * @param {?} areaid
     * @param {?} pricetype
     * @param {?} seats
     * @return {?}
     */
    function (areaid, pricetype, seats) {
        var _this = this;
        return this._addSubscriptionsToBasket(areaid, pricetype, seats).pipe(map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            // tODO type
            // the parsing method is done here to adapt the data
            /** @type {?} */
            var translations;
            _this.translator.translationsHolder.subscribe((/**
             * @param {?} translationsHolderData
             * @return {?}
             */
            function (translationsHolderData) {
                translations = translationsHolderData;
            }));
            /** @type {?} */
            var messageBody = data['s:Envelope']['s:Body'];
            if (messageBody['s:Fault'] != null) {
                /** @type {?} */
                var errorMessage = messageBody['s:Fault']['s:Code']['s:Value'];
                /** @type {?} */
                var errorText = messageBody['s:Fault']['s:Reason']['s:Text']['#text'];
                throw new Error(errorMessage + '%%%' + errorText);
            }
            else {
                /** @type {?} */
                var bskt = messageBody['ISubscriptionFacade_AddSubscriptionsToBasket_ResponseMsg']['TransactionSnapshot']['Basket'];
                console.log(bskt);
                _this.Basket.next(_this.parseItems(bskt, translations));
                return _this.parseItems(bskt, translations);
            }
        })));
    };
    /**
     * @param {?} areaid
     * @param {?} pricetype
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.addGASubscriptionsToBasket = /**
     * @param {?} areaid
     * @param {?} pricetype
     * @return {?}
     */
    function (areaid, pricetype) {
        var _this = this;
        return this._addGASubscriptionsToBasket(areaid, pricetype, null).pipe(map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            // tODO type
            // the parsing method is done here to adapt the data
            /** @type {?} */
            var translations;
            _this.translator.translationsHolder.subscribe((/**
             * @param {?} translationsHolderData
             * @return {?}
             */
            function (translationsHolderData) {
                translations = translationsHolderData;
            }));
            /** @type {?} */
            var messageBody = data['s:Envelope']['s:Body'];
            if (messageBody['s:Fault'] != null) {
                /** @type {?} */
                var errorMessage = messageBody['s:Fault']['s:Code']['s:Value'];
                /** @type {?} */
                var errorText = messageBody['s:Fault']['s:Reason']['s:Text']['#text'];
                throw new Error(errorMessage + '%%%' + errorText);
            }
            else {
                /** @type {?} */
                var bskt = messageBody['ISubscriptionFacade_AddSubscriptionsToBasket_ResponseMsg']['TransactionSnapshot']['Basket'];
                _this.Basket.next(_this.parseItems(bskt, translations));
                return _this.parseItems(bskt, translations);
            }
        })));
    };
    /**
     * @param {?} items
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.discardBasketItems = /**
     * @param {?} items
     * @return {?}
     */
    function (items) {
        var _this = this;
        return this._discardBasketItems(items).pipe(map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            // tODO type
            // the parsing method is done here to adapt the data
            /** @type {?} */
            var translations;
            _this.translator.translationsHolder.subscribe((/**
             * @param {?} translationsHolderData
             * @return {?}
             */
            function (translationsHolderData) {
                translations = translationsHolderData;
            }));
            /** @type {?} */
            var messageBody = data['s:Envelope']['s:Body'];
            if (messageBody['s:Fault'] != null) {
                /** @type {?} */
                var errorMessage = messageBody['s:Fault']['s:Code']['s:Value'];
                /** @type {?} */
                var errorText = messageBody['s:Fault']['s:Reason']['s:Text']['#text'];
                throw new Error(errorMessage + '%%%' + errorText);
            }
            else {
                /** @type {?} */
                var bskt = messageBody['ISaleFacade_DiscardBasketItems_ResponseMsg']['TransactionSnapshot']['Basket'];
                _this.Basket.next(_this.parseItems(bskt, translations));
                return _this.parseItems(bskt, translations);
            }
        })));
    };
    /**
     * @param {?} clientGuid
     * @return {?}
     */
    SeatgeekConnectionSeriesService.prototype.getCustomerExtraFields = /**
     * @param {?} clientGuid
     * @return {?}
     */
    function (clientGuid) {
        return this._getCustomerExtraFields(clientGuid).pipe(map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            /** @type {?} */
            var messageBody = data['s:Envelope']['s:Body'];
            if (messageBody['s:Fault'] != null) {
                /** @type {?} */
                var errorMessage = messageBody['s:Fault']['s:Code']['s:Value'];
                /** @type {?} */
                var errorText = messageBody['s:Fault']['s:Reason']['s:Text']['#text'];
                throw new Error(errorMessage + '%%%' + errorText);
            }
            else {
                return messageBody['ISoapEntityManagementFacade_Query_ResponseMsg']['Data']['em:Record']['em:ExtraFields'];
            }
        })));
    };
    SeatgeekConnectionSeriesService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root',
                },] }
    ];
    /** @nocollapse */
    SeatgeekConnectionSeriesService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: JsonXmlTranslatorService },
        { type: SeatgeekConnectionIdtranslatorService },
        { type: undefined, decorators: [{ type: Inject, args: [SEATGEEK_CONNECTION_CONFIG,] }] }
    ]; };
    /** @nocollapse */ SeatgeekConnectionSeriesService.ngInjectableDef = defineInjectable({ factory: function SeatgeekConnectionSeriesService_Factory() { return new SeatgeekConnectionSeriesService(inject(HttpClient), inject(JsonXmlTranslatorService), inject(SeatgeekConnectionIdtranslatorService), inject(SEATGEEK_CONNECTION_CONFIG)); }, token: SeatgeekConnectionSeriesService, providedIn: "root" });
    return SeatgeekConnectionSeriesService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SeatgeekConnectionModule = /** @class */ (function () {
    function SeatgeekConnectionModule() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    SeatgeekConnectionModule.forRoot = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        console.log('forRoot', config);
        /** @type {?} */
        var providers = [
            { provide: SEATGEEK_CONNECTION_CONFIG, useValue: config },
            SeatgeekConnectionIdtranslatorService,
            SeatgeekConnectionSeriesService
        ];
        return {
            ngModule: SeatgeekConnectionModule,
            providers: providers
        };
    };
    SeatgeekConnectionModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule, HttpClientModule
                    ],
                    declarations: []
                },] }
    ];
    return SeatgeekConnectionModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { SeatgeekConnectionModule, SEATGEEK_CONNECTION_CONFIG, SeatgeekConnectionIdtranslatorService, FileParserHelperService, SeatgeekConnectionSeriesService };

//# sourceMappingURL=ngx-seatgeek-connection.js.map